import { render } from "./defaultSetting.vue?vue&type=template&id=bc28608e&scoped=true&ts=true"
import script from "./defaultSetting.vue?vue&type=script&lang=ts"
export * from "./defaultSetting.vue?vue&type=script&lang=ts"

import "./defaultSetting.vue?vue&type=style&index=0&id=bc28608e&lang=scss&scoped=true"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc28608e"]])

export default __exports__